import React from "react"
import SinglePerformance from "./SinglePerformance"
import { graphql, useStaticQuery } from "gatsby"

const getPerformanceData = graphql`
  query {
    allContentfulPerformances(sort: { fields: when, order: ASC }) {
      edges {
        node {
          createdAt
          title
          date
          location
          id: contentful_id
          content {
            json
          }
          when
        }
      }
    }
  }
`

const PerformanceList = ({ filteredDate }) => {
  const data = useStaticQuery(getPerformanceData)
  const yearMonth = filteredDate
    ? `${filteredDate.getFullYear()}-${String(filteredDate.getMonth() + 1).padStart(2, "0")}`
    : null
  const filteredPerformenceContent = data.allContentfulPerformances.edges.filter(
    item => !yearMonth || (item.node.when && item.node.when.startsWith(yearMonth))
  )
  if (filteredPerformenceContent.length === 0 || !filteredPerformenceContent) {
    return <div className="text-center mt-5">No concert entries</div>
  }
  return (
    <div>
      {filteredPerformenceContent.map(({ node }) => {
        return (
          <SinglePerformance
            key={node.id}
            title={node.title}
            date={node.date}
            location={node.location}
            content={node.content}
          />
        )
      })}
    </div>
  )
}

export default PerformanceList
